import Cookies from 'js-cookie';
import { LOGIN_REFERRER_KEY } from '../constants';
import { CookieKey } from '../enums';
import { getDomain, isCSR } from './env';
export const setLoginReferer = () => {
    if (!isCSR())
        return;
    const referer = window.location.pathname + window.location.search + window.location.hash;
    // store2 internally call JSON.stringify which adds unwanted quotes to string so localStorage is used
    sessionStorage.setItem(LOGIN_REFERRER_KEY, referer);
};
export const deleteCookieForSession = () => Cookies.remove(CookieKey.OBS_SESSION, { path: '/', domain: getDomain() });
export const hasCookieForSession = () => {
    const cookie = Cookies.get(CookieKey.OBS_SESSION);
    return !!cookie && cookie === 'true';
};
//# sourceMappingURL=clientStorage.js.map